<template>
  <div class="d-flex-column">
    <div :class="{'grey--text': notImportant}" style="text-align: center; font-size: 10px;" class="font-weight-bold">{{ title || 'Title' }}</div>
    <div class="d-flex align-center justify-center">
      <div style="background-color: lightgrey; padding: 0px 2px; border-radius: 5px; cursor: pointer;" v-no-focus v-tooltip="subtractTooltip" fab x-small @click="subtract_num"><v-icon size="12">mdi-minus</v-icon></div>
      <v-chip v-tooltip="info" :class="{'grey--text': notImportant}" small outlined :color="notImportant ? '' : 'primary'" label class="mx-2 font-weight-bold">{{ value }}</v-chip>
      <div style="background-color: lightgrey; padding: 0px 2px; border-radius: 5px; cursor: pointer;" v-no-focus v-tooltip="addTooltip" fab x-small @click="add_num"><v-icon size="12">mdi-plus</v-icon></div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    'value': Number,
    'max': Number,
    'min': Number,
    'title': String,
    'subtractTooltip': String,
    'addTooltip': String,
    'notImportant': Boolean,
    'info': String
  },
  methods: {
    add_num() {
      if (!this.max || this.value < this.max) {
        this.$emit('input', this.value + 1);
      }
    },
    subtract_num() {
      if (this.value > 0 && (this.value > this.min || !this.min)) {
        this.$emit('input', this.value - 1);
      }
    }
  }
}
</script>